import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const personalSettingsRoute: InvariantJiraRoute = {
	name: 'personal-settings',
	path: '/secure/ViewPersonalSettings.jspa',
};
